import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

function AdminCatalogManagement() {
  return (
    <Box>
      <Typography variant="h3" component="h2" gutterBottom sx={{ mb: 3 }}>
        Catalog Management
      </Typography>
      <Paper sx={{ p: 3, boxShadow: 1 }}>
        <Typography variant="h4" component="h3" gutterBottom>
          Add New Catalog Item
        </Typography>
        <Typography variant="body1">
          (Coming Soon: Form to add catalog items)
        </Typography>
      </Paper>
      <Paper sx={{ p: 3, mt: 3, boxShadow: 1 }}>
        <Typography variant="h4" component="h3" gutterBottom>
          View/Manage Catalogs
        </Typography>
        <Typography variant="body1">
          (Coming Soon: Table to list and manage catalog items)
        </Typography>
      </Paper>
    </Box>
  );
}

export default AdminCatalogManagement;